import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';
import getFileURL from './getFileURL';

const getMonthlyReportDownloadURL = async (report) => {
    const reportId = report?.id || report?._id;
    if (!reportId) {
        throw new Error('Monthly report ID is required.');
    }

    const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
    if (useExpress) {
        const response = await axios.get(`${getExpressAPIHost()}/producer-monthly-reports/download/${reportId}`);
        return response.data?.Location ?? response.data;
    }

    if (report.attachment) {
        return getFileURL(`MonthlyReport/${report.attachment}`);
    }

    const response = await axios.get(`${getAPIHost()}/download-monthly-report/${reportId}`);
    return getFileURL(response.data?.Location ?? response.data);
};

export default getMonthlyReportDownloadURL;
